<template>
  <div>
    <div v-if="link && link.href && link.text">
      <a :href="link.href">{{ link.text }}</a>
    </div>

    <div v-else-if="link && link.href && !link.text">
      <a :href="link.href">{{ link.href }}</a>
    </div>

    <div
      v-else-if="link && link.text"
      v-html="link.text"
    />
  </div>
</template>

<script>

  export default {
    name: 'ZgSideBarData',
    props: {
      /**
       * A link-object that should contain either a text prop, a href prop or both.
       */
      link: {
        type: Object,
        required: true,
        validator: link => {
          return !!link &&
            (!!link.text ||
              !!link.href)
        }
      }
    }
  }
</script>
